import React from "react";
import styled from "styled-components";
import { GiServerRack } from "react-icons/gi";
import { IoIosTimer } from "react-icons/io";
import { HiOutlinePuzzlePiece } from "react-icons/hi2";
import { ImCompass } from "react-icons/im";

const ScaleUp = () => {
  const handleTalkToTeam = () => {
    window.location.href = "/contact-us";
  };

  return (
    <TheScaleUp>
      <div className="container">
        <div className="built-to-scale-section">
          <div className="section-header">
            <h3>Built to scale with OEMs</h3>
            <p className="section-subtitle">
              We act as an extension of your R&D team, integrating seamlessly
              into your process to accelerate projects and scale production.
            </p>
          </div>

          <div className="scale-features">
            <div className="feature-grid">
              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <GiServerRack className="feature-icon" />
                </div>
                <h4>Align with your R&D needs</h4>
                <p>
                  Seamless integration with your existing R&D processes and
                  teams for maximum efficiency.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <IoIosTimer className="feature-icon" />
                </div>
                <h4>Accelerate stalled projects</h4>
                <p>
                  Get projects back on track with our structured approach and
                  proven methodologies.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <HiOutlinePuzzlePiece className="feature-icon" />
                </div>
                <h4>Ensure compliance at every stage</h4>
                <p>
                  Built-in regulatory expertise ensures compliance from concept
                  through production.
                </p>
              </div>

              <div className="feature-card">
                <div className="feature-icon-wrapper">
                  <ImCompass className="feature-icon" />
                </div>
                <h4>Scale with global facilities</h4>
                <p>
                  Access to international manufacturing facilities for
                  cost-effective scaling.
                </p>
              </div>
            </div>
          </div>

          <div className="cta-container">
            <div className="cta-content">
              <h3>Ready to scale your medical device manufacturing?</h3>
              <p>
                Partner with Medichy for end-to-end solutions that combine
                regulatory expertise with scalable production capabilities.
              </p>
              <button className="btn-primary" onClick={handleTalkToTeam}>
                START PARTNERSHIP
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </TheScaleUp>
  );
};

const TheScaleUp = styled.div`
  width: 100%;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  padding: 4rem 0;

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
  }

  .built-to-scale-section {
    width: 100%;
  }

  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    h3 {
      font-size: 2.5rem;
      font-weight: 700;
      color: #1a1a1a;
      margin-bottom: 1rem;
      position: relative;
      display: inline-block;

      &::after {
        content: "";
        position: absolute;
        bottom: -12px;
        left: 50%;
        transform: translateX(-50%);
        width: 60px;
        height: 3px;
        background: linear-gradient(135deg, #3182ce, #2c5282);
        border-radius: 2px;
      }
    }

    .section-subtitle {
      font-size: 1.25rem;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
      margin: 1.5rem auto 0;
    }
  }

  .scale-features {
    margin: 3rem 0 4rem;

    .feature-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
    }

    .feature-card {
      background: white;
      border-radius: 20px;
      padding: 2rem;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      transition: all 0.3s ease;
      text-align: center;
      border: 1px solid rgba(49, 130, 206, 0.1);

      &:hover {
        transform: translateY(-8px);
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
        border-color: rgba(49, 130, 206, 0.3);

        .feature-icon-wrapper {
          transform: scale(1.1);
          background: linear-gradient(135deg, #2c5282, #3182ce);
        }
      }

      .feature-icon-wrapper {
        width: 80px;
        height: 80px;
        background: linear-gradient(135deg, #3182ce, #2c5282);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 1.5rem;
        transition: all 0.3s ease;

        .feature-icon {
          color: white;
          font-size: 2.5rem;
        }
      }

      h4 {
        font-size: 1.25rem;
        font-weight: 700;
        color: #1a1a1a;
        margin-bottom: 1rem;
        line-height: 1.3;
      }

      p {
        font-size: 1rem;
        color: #666;
        line-height: 1.5;
        margin: 0;
      }
    }
  }

  .cta-container {
    background: linear-gradient(135deg, #3182ce 0%, #2c5282 100%);
    border-radius: 24px;
    padding: 4rem;
    text-align: center;
    color: white;
    margin-top: 2rem;
    box-shadow: 0 10px 40px rgba(49, 130, 206, 0.3);
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 70%
      );
      animation: pulse 4s ease-in-out infinite;
    }

    @keyframes pulse {
      0%,
      100% {
        transform: scale(1);
        opacity: 0.5;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.8;
      }
    }

    .cta-content {
      max-width: 700px;
      margin: 0 auto;
      position: relative;
      z-index: 1;

      h3 {
        font-size: 2.25rem;
        font-weight: 700;
        margin-bottom: 1rem;
        line-height: 1.3;
      }

      p {
        font-size: 1.25rem;
        opacity: 0.95;
        margin-bottom: 2.5rem;
        line-height: 1.6;
      }

      .btn-primary {
        display: inline-flex;
        align-items: center;
        gap: 0.75rem;
        background: white;
        color: #3182ce;
        border: none;
        padding: 1rem 2.5rem;
        font-size: 1rem;
        font-weight: 600;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        text-transform: uppercase;
        letter-spacing: 0.5px;

        &:hover {
          background: #f7fafc;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(255, 255, 255, 0.3);

          svg {
            transform: translateX(5px);
          }
        }

        svg {
          color: #3182ce;
          transition: transform 0.3s ease;
        }
      }
    }
  }

  /* Media Queries */
  @media screen and (max-width: 1366px) {
    padding: 3.5rem 0;

    .container {
      padding: 0 1.5rem;
    }

    .section-header {
      h3 {
        font-size: 2.25rem;
      }

      .section-subtitle {
        font-size: 1.2rem;
      }
    }

    .scale-features .feature-grid {
      gap: 1.5rem;
    }

    .cta-container {
      padding: 3.5rem;
    }
  }

  @media screen and (max-width: 1200px) {
    .scale-features .feature-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 2rem;
    }

    .feature-card {
      padding: 1.75rem;
    }

    .cta-container .cta-content {
      h3 {
        font-size: 2rem;
      }

      p {
        font-size: 1.1rem;
      }
    }
  }

  @media screen and (max-width: 900px) {
    padding: 3rem 0;

    .section-header {
      margin-bottom: 3rem;

      h3 {
        font-size: 2rem;
      }

      .section-subtitle {
        font-size: 1.1rem;
        padding: 0 1rem;
      }
    }

    .scale-features {
      margin: 2rem 0 3rem;

      .feature-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 1.5rem;
      }

      .feature-card {
        padding: 1.5rem;

        .feature-icon-wrapper {
          width: 70px;
          height: 70px;

          .feature-icon {
            font-size: 2rem;
          }
        }

        h4 {
          font-size: 1.1rem;
        }

        p {
          font-size: 0.95rem;
        }
      }
    }

    .cta-container {
      padding: 3rem 2rem;
      border-radius: 20px;

      .cta-content {
        h3 {
          font-size: 1.75rem;
        }

        p {
          font-size: 1rem;
          margin-bottom: 2rem;
        }

        .btn-primary {
          padding: 0.875rem 2rem;
          font-size: 0.95rem;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    padding: 2.5rem 0;

    .container {
      padding: 0 1rem;
    }

    .section-header {
      margin-bottom: 2.5rem;

      h3 {
        font-size: 1.75rem;
      }

      .section-subtitle {
        font-size: 1rem;
      }
    }

    .scale-features {
      margin: 1.5rem 0 2.5rem;

      .feature-grid {
        grid-template-columns: 1fr;
        gap: 1.5rem;
        max-width: 400px;
        margin: 0 auto;
      }

      .feature-card {
        padding: 1.5rem;
        text-align: center;

        .feature-icon-wrapper {
          width: 70px;
          height: 70px;

          .feature-icon {
            font-size: 2rem;
          }
        }

        h4 {
          font-size: 1.1rem;
        }

        p {
          font-size: 0.95rem;
        }
      }
    }

    .cta-container {
      padding: 2.5rem 1.5rem;
      border-radius: 16px;

      .cta-content {
        h3 {
          font-size: 1.5rem;
        }

        p {
          font-size: 0.95rem;
          margin-bottom: 1.75rem;
        }

        .btn-primary {
          padding: 0.75rem 1.75rem;
          font-size: 0.9rem;

          svg {
            width: 18px;
            height: 18px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 420px) {
    padding: 2rem 0;

    .section-header {
      h3 {
        font-size: 1.5rem;
      }

      .section-subtitle {
        font-size: 0.9rem;
      }
    }

    .scale-features {
      .feature-card {
        padding: 1.25rem;

        .feature-icon-wrapper {
          width: 60px;
          height: 60px;

          .feature-icon {
            font-size: 1.75rem;
          }
        }

        h4 {
          font-size: 1rem;
        }

        p {
          font-size: 0.9rem;
        }
      }
    }

    .cta-container {
      padding: 2rem 1rem;

      .cta-content {
        h3 {
          font-size: 1.25rem;
        }

        p {
          font-size: 0.9rem;
        }

        .btn-primary {
          padding: 0.7rem 1.5rem;
          font-size: 0.85rem;

          svg {
            width: 16px;
            height: 16px;
          }
        }
      }
    }
  }

  @media screen and (max-width: 350px) {
    padding: 1.5rem 0;

    .container {
      padding: 0 0.75rem;
    }

    .section-header {
      h3 {
        font-size: 1.25rem;
      }

      .section-subtitle {
        font-size: 0.85rem;
      }
    }

    .scale-features {
      .feature-card {
        padding: 1rem;

        .feature-icon-wrapper {
          width: 55px;
          height: 55px;
          margin-bottom: 1rem;

          .feature-icon {
            font-size: 1.5rem;
          }
        }

        h4 {
          font-size: 0.95rem;
        }

        p {
          font-size: 0.85rem;
        }
      }
    }

    .cta-container {
      padding: 1.5rem 0.75rem;

      .cta-content {
        h3 {
          font-size: 1.1rem;
        }

        p {
          font-size: 0.85rem;
        }

        .btn-primary {
          padding: 0.6rem 1.25rem;
          font-size: 0.8rem;

          svg {
            width: 14px;
            height: 14px;
          }
        }
      }
    }
  }
`;

export default ScaleUp;
